import { render, staticRenderFns } from "./KasbonAccess.vue?vue&type=template&id=a8bc6af2"
import script from "./KasbonAccess.vue?vue&type=script&lang=js"
export * from "./KasbonAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports